/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
export * from './auto-prefixer';
export * from './object-extend';
export * from './add-alias';
//# sourceMappingURL=/usr/local/google/home/mmalerba/flex-layout/src/lib/utils/index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/flex-layout/utils/index.js
// module id = 1012
// module chunks = 3